import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FiChevronDown, FiLogOut, FiMenu } from "react-icons/fi";
import { removeAuthedUser } from "../../redux/actions/AuthUserActions";
import "./dashboard.css";

// Closes a dropdown when the user clicks anywhere else
export function useOutsideClose(open, setOpen) {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open, setOpen]);

  return ref;
}

// Top bar shared by the dashboard spaces
function TopBar({ toggleSidebar, left, right, menuItems = [] }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useOutsideClose(menuOpen, setMenuOpen);

  const initials = `${user?.firstname?.[0] || ""}${
    user?.lastname?.[0] || ""
  }`.toUpperCase();

  const handleLogout = () => {
    setMenuOpen(false);
    Swal.fire({
      title: "Voulez-vous vraiment vous déconnecter ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#051259",
      cancelButtonColor: "#c5cad8",
      confirmButtonText: "Se déconnecter",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.isConfirmed) dispatch(removeAuthedUser());
    });
  };

  return (
    <header className="dash-topbar">
      <button
        type="button"
        className="dash-icon-button dash-menu-toggle"
        onClick={toggleSidebar}
        aria-label="Ouvrir le menu"
      >
        <FiMenu />
      </button>

      <div className="dash-topbar-left">{left}</div>

      <div className="dash-topbar-right">
        {right}

        <div className="dash-dropdown" ref={menuRef}>
          <button
            type="button"
            className="dash-account"
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="dash-avatar" aria-hidden="true">
              {initials || "?"}
            </span>
            <span className="dash-account-name">
              {user?.firstname} {user?.lastname}
            </span>
            <FiChevronDown aria-hidden="true" />
          </button>

          {menuOpen && (
            <div className="dash-menu" role="menu">
              <p className="dash-menu-head">
                <strong>
                  {user?.firstname} {user?.lastname}
                </strong>
                <span>{user?.email}</span>
              </p>
              {menuItems.map(({ label, icon: Icon, to }) => (
                <button
                  key={to}
                  type="button"
                  role="menuitem"
                  className="dash-menu-item"
                  onClick={() => {
                    setMenuOpen(false);
                    navigate(to);
                  }}
                >
                  <Icon aria-hidden="true" /> {label}
                </button>
              ))}
              <button
                type="button"
                role="menuitem"
                className="dash-menu-item is-danger"
                onClick={handleLogout}
              >
                <FiLogOut aria-hidden="true" /> Déconnexion
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default TopBar;
